module.exports = __webpack_public_path__ + "static/media/square.133db7a8.svg";